import { flatMap } from "rxjs/operators";
import { ofType } from "redux-observable";
import type { Action$ } from "redux-observable";
import { RESPONSE_UNAUTHENTICATED } from "../../../actions/actionTypes";
import { logout } from "../../../actions/owner/auth";

const unauthenticatedResponse$ = (action$: Action$) => action$.pipe(ofType(RESPONSE_UNAUTHENTICATED), flatMap(() => [logout()]));

export default unauthenticatedResponse$;